import { mapTaxResultFromResponse } from 'src/app/modules/tax-result/mappers/security/map-tax-result-from-response';
import { SecurityCardTaxResultItem } from 'src/app/modules/tax-result/models/security-card-tax-results-item';
import { SecurityResponseWithNestedObjectsAuditable } from 'src/app/web-api-client';

export const mapSecurityTaxResultFromResponse = (
  response: SecurityResponseWithNestedObjectsAuditable
): SecurityCardTaxResultItem => ({
  securityId: response?.securityId,
  entityTypeName: response.entity?.entityType?.name,
  investingJurisdictionName: response.investmentJurisdiction?.country?.name,
  securityTypeName: response.securityType?.name,
  securityStatusId: response.securityStatus?.securityStatusId,
  securityStatusName: response.securityStatus?.name,
  modifiedBy: response.modifiedBy ? response.modifiedBy.split('|').pop() : '',
  modified: response.modified,
  taxResults: mapTaxResultFromResponse(response.securityTaxResultItems!),
  transactionTypeName: response.transactionType?.name,
  transactionTypeId: response.transactionType?.transactionTypeId,
  clientName: response.entity?.client?.name,
  approved: response.approved,
  approvedBy: response.approvedByNavigation
    ? `${response.approvedByNavigation?.firstName} ${response.approvedByNavigation?.lastName}`
    : '',
});
